import { formatISO } from 'date-fns';

/**
 * Formats an ExcelJS date without shifting its calendar day.
 *
 * Excel stores dates as timezone-free day numbers, but ExcelJS converts them
 * to JavaScript Dates at midnight UTC. Formatting that Date directly in a US
 * timezone can produce the wrong date by shifting the TZ. Rebuilding local
 * midnight from the UTC calendar components preserves the date entered in Excel
 * while allowing formatISO to return the application's local date-string format.
 */
export function formatExcelDate(value: Date) {
  const localDate = new Date(
    value.getUTCFullYear(),
    value.getUTCMonth(),
    value.getUTCDate(),
  );
  return formatISO(localDate, { representation: 'date' });
}
